:host {
  font-family: var(--uui-primary-font-family);
  font-weight: var(--uui-font-weight-normal);
  font-size: var(--uui-small-font-size);
  line-height: var(--uui-sm-line-height);  
  --uui-percentile-bar-height: var(--uui-medium-padding);
  --uui-percentile-bar-border-radius: var(--uui-medium-padding);
  --uui-percentile-bar-width: auto;
}

.uui-percentile-bar-container {
  display: flex;            
  width: 100%;             
  align-items: center;     
  height: 100%;
}

.uui-percentile-bar-score {
  width: var(--uui-percentile-bar-width);              
  margin-right: 5px;        
  padding: 2px;             
}

.uui-percentile-bar-score-right {
  margin-left: var(--uui-x-small-padding);
}

.uui-percentile-bar-segments {
  background-color: var(--uui-gray-06);  
  flex-grow: 1;
  height: var(--uui-percentile-bar-height);
  display: flex;
  border-radius: var(--uui-percentile-bar-border-radius);
}

.uui-percentile-bar-segment {
  width: 25%;              
  height: 100%;            
  margin-right: 1.5px;        
}

.uui-percentile-bar-segment:last-child {
  margin-right: 0;
}

.uui-percentile-bar-segment:first-child .uui-percentile-bar-fill {
  border-top-left-radius: var(--uui-percentile-bar-border-radius);
  border-bottom-left-radius: var(--uui-percentile-bar-border-radius);
}

.uui-percentile-bar-segment:last-child .uui-percentile-bar-fill {
  border-top-right-radius: var(--uui-percentile-bar-border-radius);
  border-bottom-right-radius: var(--uui-percentile-bar-border-radius);
}

.uui-percentile-bar-fill {
  height: 100%;             
  width: 100%;
  left: 0;                  
}